import React, { useEffect, useState } from 'react';
import css from './ReminderOptions.module.css';
import {
  CheckboxCardGroup,
  CheckboxCardGroupSizing,
  H2,
  Paragraph,
  PhoneField,
  StackedColumn,
  StackedColumnSpacing,
  TextLink,
} from '../../../../../core';
import { ContactDetails } from '../../../../../api/models';
import { PhoneUtility } from '@mchs/web-core';

const agreeValue = 'agree';

export interface ReminderOptionsProps {
  patientContactDetails?: ContactDetails;
  patientAgrees: boolean;
  validate: boolean;
  onChangePatientAgrees: (patientAgrees: boolean) => void;
  onMobilePhoneChanged: (value: string) => void;
}

const ReminderOptions: React.FC<ReminderOptionsProps> = (
  props: ReminderOptionsProps
) => {
  const [showPhoneEdit, setShowPhoneEdit] = useState<boolean>(false);
  const [patientAgrees, setPatientAgrees] = useState<string[]>(
    props.patientAgrees ? [agreeValue] : []
  );

  useEffect(() => {
    setPatientAgrees(props.patientAgrees ? [agreeValue] : []);
  }, [props.patientAgrees]);

  const showPhoneEditClicked = () => {
    setShowPhoneEdit(true);
  };

  const onMobilePhoneChanged = (value: string) => {
    props.onMobilePhoneChanged(value);
  };

  const onPatientAgreesChanged = (selectedvalues: string[]) => {
    setPatientAgrees(selectedvalues);
    props.onChangePatientAgrees(selectedvalues.includes(agreeValue));
  };

  return (
    <StackedColumn spacing={StackedColumnSpacing.Wide}>
      <StackedColumn spacing={StackedColumnSpacing.Normal}>
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <H2 text="Appointment Reminders" />
          <div>
            <Paragraph text="Text message (SMS) reminders will be sent to " />
            <Paragraph
              text={PhoneUtility.formatPhoneNumber(
                props.patientContactDetails?.mobileNumber
                  ? props.patientContactDetails?.mobileNumber
                  : props.patientContactDetails?.phoneNumber
              )}
              bold={true}
            />
            {props.patientContactDetails?.emailAddress &&
            props.patientContactDetails.emailAddress.length > 0 ? (
              <>
                <Paragraph text=" and email reminders to " />
                <Paragraph
                  text={props.patientContactDetails.emailAddress}
                  bold={true}
                />{' '}
              </>
            ) : null}
            <Paragraph text=". To receive text message (SMS) reminders, a mobile phone number is required. " />
            <TextLink
              caption="Please enter a different number if needed."
              onClick={showPhoneEditClicked}
            />
          </div>
        </StackedColumn>
        {showPhoneEdit ? (
          <div className={css.phoneField}>
            <PhoneField
              value={props.patientContactDetails?.mobileNumber ?? ''}
              label="Mobile number"
              required={false}
              validate={props.validate}
              onChange={onMobilePhoneChanged}
            />
          </div>
        ) : null}
      </StackedColumn>
      <CheckboxCardGroup
        required={true}
        fullWidth={true}
        sizing={CheckboxCardGroupSizing.Small}
        validate={props.validate}
        requiredErrorMessageOverride="You must agree to receive appointment reminders"
        checkboxOptions={[
          {
            value: agreeValue,
            label:
              'I agree to receive appointment reminders from text message (SMS) and email from Marshfield Clinic Health System.',
          },
        ]}
        selectedValues={patientAgrees}
        onChange={onPatientAgreesChanged}
      />
    </StackedColumn>
  );
};

export default ReminderOptions;
